export const getInitialReadMessageStatus = (isCallee, message) => {
  const { side, type } = message;
  const isVoiceMessage = type === "original" || type === "translation";
  if (isVoiceMessage) {
    return true;
  }
  return (isCallee && side === "B") || (!isCallee && side === "A");
};
